export enum FileTransferError {
  Cancelled = 1000
}
